import api from "./api-service"


class CustomerService {
    async getCustomers(filter) {
     return await api.get("/Customer/GetCustomers",  filter).then((response) => {
         if (response.data) {
           return response.data;
         }
       })
       .catch((error) => {
         console.log(error);
         return error;
       });
   }
 }
 export default new CustomerService();